import { observer } from 'mobx-react'

import { OrganisationDashboardDefault } from 'Modules/dashboard/components/OrganisationDashboardDefault/OrganisationDashboardDefault'
import { OrganisationDashboardLegacy } from 'Modules/dashboard/components/OrganisationDashboardLegacy/OrganisationDashboardLegacy'

import { useStore } from 'Stores/index'

export const OrganisationDashboard = observer(() => {
  const { portalConfigStore } = useStore()
  const { portalConfig } = portalConfigStore

  if (portalConfig?.enableNewAdminDashboard) {
    return <OrganisationDashboardDefault />
  }

  return <OrganisationDashboardLegacy />
})
